export default "__VITE_ASSET__GVU09E7S__"